import { useEffect, useMemo, useState } from "react";
import { IHeaderTable } from "../../../../types/global";

export const useDeliveryOrderListPdfHeader = () => {
  const [headers, setHeaders] = useState<IHeaderTable[]>([]);
  const columns = useMemo<IHeaderTable[]>(
    () => [
      {
        thaiLabel: "",
        width: 12,
      },
      {
        thaiLabel: "สินค้า",
        width: 300,
        align: "left",
      },
      {
        thaiLabel: "จำนวน",
        width: 60,
        align: "right",
      },
      {
        thaiLabel: "หน่วย",
        width: 50,
      },
    ],
    []
  );
  useEffect(() => {
    setHeaders(columns);
  }, [columns]);

  return headers;
};
